export const sponsors = (state) => {
    return state.sponsors;
};
